module.exports = __webpack_public_path__ + "img/cordial@2x.0000e5e.webp";